module.exports = __webpack_public_path__ + "static/media/Top-Tips-to-Make-Your-Car-Eco-Friendlier-on-Roads-1.6b9e5b50.jpg";